import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { LockOutlined } from '@ant-design/icons'
import { useApi } from '../../api/useApi'
import SingleObject from '../../components/singleObject'
import StatusMessage from '../../components/statusMessage/StatusMessage'
import { setFlags } from '../../api/flagApi'

const SingleBrukare = () => {
  type Param = { id: string; namn: string }
  const { id, namn } = useParams<Param>()
  const dispatch = useDispatch()
  const api = useApi()
  const [nekad, setNekad] = useState(false)

  // Bruten ur useEffect så den kan köras om efter en sparad hantering — vyn nedanför
  // läser flaggorna ur redux och vet inte själv vilken typ och nyckel som ska hämtas.
  const laddaFlaggor = useCallback(async () => {
    const svar = await setFlags(api, dispatch, 'brukare', id)
    setNekad(svar === 'nekad')
  }, [api, dispatch, id])

  useEffect(() => {
    laddaFlaggor()
  }, [laddaFlaggor])

  /**
   * Brukaren ligger utanför tittarens Behörighet (#7). Backend har alltid nekat med 403,
   * men felet swaldes i api-lagret och sidan renderade tomhet — omöjligt att skilja från
   * "brukaren har inga flaggor". Samma besked som rutt-vakten i #50 ger, så att ett
   * nekande ser likadant ut oavsett vilken väg man tog dit.
   */
  if (nekad) {
    return (
      <StatusMessage
        icon={<LockOutlined />}
        title="Brukaren ligger utanför din behörighet"
        body="Vilka brukare du kan se styrs av din behörighet i Pejlen. Kontakta din administratör om du behöver se denna brukare."
      />
    )
  }

  return <SingleObject obj={{ namn }} heading={`Brukare - ${namn}`} onHandled={laddaFlaggor} />
}

export default SingleBrukare
